import http from "../../plugins/axios";

export default {
  getUserList(data) {
    return http.get({
      url: `/la/admin/tenant/coin/getCoinPage`,
      data
    });
  },
  coinUpdate(data) {
    return http.post({
      url: `/la/admin/tenant/coin/update`,
      data
    })
  },

  tenantCoinList(data) {
    return http.get({
      url: `/la/admin/tenant/coin/coin/list`,
      data
    })
  },

  tenantChainist() {
    return http.get({
      url: `/la/admin/coin/chain/list`,
    })
  },


};
